<section class="wan website-container">
  <div class="wan-info">
    <h6 class="wan-title page-second-heading">{{'WEBSITE.NORDIC.TITLE' | translate}}</h6>
    <p class="wan-description page-description" [innerHTML]="'WEBSITE.NORDIC.DESCRIPTION' | translate | safe: 'html'"></p>

    <app-button
      class="book-a-demo-btn"
      [routerLink]="['/book-a-demo']"
      [config]="{
        view: 'primary',
        icon: { name: 'specialArrowRight', position: 'suffix' },
        label: 'COMMON.BOOK_A_DEMO' | translate,
    }"></app-button>
  </div>

  <div class="images">
    <img class="grid-item image image-desktop image-large" [ngSrc]="'assets/img/website/nordic/nordic_1.png'" width="860" height="1078" alt="Nordic illustration" />
    <img class="grid-item image image-desktop" [ngSrc]="'assets/img/website/nordic/nordic_2.png'" width="860" height="518" alt="Nordic illustration" />

    <picture class="grid-item">
      <source media="(max-width: 960) or (min-width: 1441px)" srcset="../../../assets/img/website/nordic/nordic_3_dt.png">
      <source media="(min-width: 961) and (max-width: 1440px)" srcset="assets/img/website/nordic/nordic_3.png">
      <img class="image" src="../../../assets/img/website/nordic/nordic_3_dt.png" alt="Nordic illustration" />
    </picture>
  </div>
</section>
